module.exports = __webpack_public_path__ + "img/sliding.8205024.svg";